module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[80]201.b479ed6.woff2";